import { useState } from 'react'

import Breakdown from './CohortBreakdown'
import { changeSplit, type CohortPath, type TreeSplits } from './exploration'

import type { AttributionFilters, AttributionSummary } from '@/api/attributionObservability'

export default function SourceDiagnostics({
  filters,
  summary,
  onFilter,
}: {
  filters: AttributionFilters
  summary: AttributionSummary
  onFilter: (path: CohortPath) => void
}) {
  const [splits, setSplits] = useState<TreeSplits>({ '[]': 'label_source' })
  const [selectedPath, setSelectedPath] = useState<CohortPath>()
  return (
    <Breakdown
      filters={filters}
      summary={summary}
      metric="labels"
      splits={splits}
      onSplit={(path, dimension) => {
        setSelectedPath(undefined)
        setSplits(changeSplit(splits, path, dimension))
      }}
      onReset={() => {
        setSelectedPath(undefined)
        setSplits({ '[]': 'label_source' })
      }}
      onFilter={onFilter}
      selectedPath={selectedPath}
      onViewMeetings={setSelectedPath}
      onCloseMeetings={() => setSelectedPath(undefined)}
    />
  )
}
